import axios from "axios";

export const descargarArchivo =  async (url,nombre) =>{
        //const respuesta = await fetch(url);

        try {
                const respuesta = await axios.get(url, { responseType: "blob" });
                const blob = new Blob([respuesta.data]);
                const enlace = document.createElement("a");
                const urlBlob = window.URL.createObjectURL(blob);

                enlace.href = urlBlob;
                enlace.download = nombre;
                document.body.appendChild(enlace);
                enlace.click();
                document.body.removeChild(enlace);
                window.URL.revokeObjectURL(urlBlob);
        } catch (error) {
                window.open(url)
                console.error("Error al descargar el archivo:", error);
        }
}